export class RoleDto {
    code:               string;
    name:               string;
    hierarchy_level:    number;
    forestCode:         string;
    regionCode:         string;
    districtCode:       string;

    constructor(data: any) {
        this.code = data.code;
        this.name = data.name;
        this.hierarchy_level = data.hierarchy_level;
        this.forestCode = data.forestCode;
        this.regionCode = data.regionCode;
        this.districtCode = data.districtCode;
    }
}

export class UserRolesDto {
    id:           number;
    userId:       number;
    roleCode:     number;
    regionCode:   string;
    forestCode:   string;
    districtCode: string;
}

export class UserDto {
    id?:          number;
    firstName?:   string;
    lastName?:    string;
    email?:       string;
    status?:      string;
    regions?:     string[];
    forests?:     string[];
    roles?:       RoleDto[];
    privileges?:  string[];
    userRoles?:   UserRolesDto[];
    phoneNumber?: string;
    createdAt?:   Date;
    updatedAt?:   Date;
    lastVisit?:   Date;
    isNationalAdmin?: boolean;
    isRegionalAdmin?: boolean;
    isSupportUser?: boolean;

    constructor(data: any) {
        this.id = data.id;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.email = data.email;
        this.status = data.status;
        this.regions = data.regions;
        this.forests = data.forests;
        this.roles = data.roles
        this.userRoles = data.userRoles;
        this.phoneNumber = data.phoneNumber;
        this.createdAt = data.created;
        this.updatedAt = data.updated;
        this.lastVisit = data.lastVisit;
        this.isNationalAdmin = data.isNationalAdmin;
        this.isRegionalAdmin = data.isRegionalAdmin;
        this.isSupportUser = data.isSupportUser;
    }
}

export interface SessionUserRole {
    id: number;
    userId: number;
    roleCode: string;
    regionCode: string;
    forestCode: string;
    districtCode: string;
    privileges: string[];
}

export interface SessionUser {
    regionRoleMap?: string;
    regionsUserCanEdit?: string[];
    id: number;
    firstName?: string;
    lastName?: string;
    email?: string;
    status: string;
    phoneNumber?: string;
    lastVisit?: Date;
    roles?: SessionUserRole[];
    privileges?: string[];
    isNationalAdmin?: boolean;
    isRegionalAdmin?: boolean;
    isSupportUser?: boolean;
}

export interface Privileges {
    code:               string;
    name:               string;
}

export interface RegionDtoList {
    list: RegionDto[];
}

export interface RegionDto {
    regionCode: string;
    regionName: string;
    forests:    ForestDto[];
    allForests: ForestDto[];
    roles?:     RoleDto[];
    role?:      string;
}

export class ForestDto {
	code: string;
	forestName: string;
	permitTypes?: any;
	state?: string;
	states?: string[];
	region: string;
	regionCode: string;
	forestNameShort: string;
	forestNameFormal?: string;
	active: boolean;
	mapUrl?: string;
	districtOfficesUrl?: string;

    constructor(data: any) {
        this.code = data.code;
        this.forestName = data.forestName;
        this.permitTypes = data.permitTypes;
	    this.state = data.state;
	    this.states = data.states;
	    this.region = data.region;
	    this.regionCode = data.regionCode;
	    this.forestNameShort = data.forestNameShort;
	    this.forestNameFormal = data.forestNameFormal;
	    this.active = data.active;
	    this.mapUrl = data.mapUrl;
	    this.districtOfficesUrl = data.districtOfficesUrl;
    }
}

export interface ForestProductDto {
    code:        string;
    forestName:  string;
    permitTypes?: any;
    state?:       string;
    states?:      string[];
    region:      string;
    regionCode:  string;
    forest_name_short: string;
    product: any;
    active: boolean;
}

export interface AlertDto {
    title:  string;
    message: string;
    type: string;
    scope: string;
    startTime: Date;
    endTime: Date;
}

export class PermitDto {
    permitId?:            string;
    permitNumber?:        number;
    processed?:           boolean;
    product:              string;
    productQuantity:      number;
    forestId:             number;
    orgStructureCode?:    string;
    firstName:            string;
    lastName:             string;
    emailAddress:         string;
    woodCost?:            number;
    quantity:             number;
    totalCost:            number;  
    status:               string;
    permitteeInfo:        JSON;
    permitExpireDate:     string;
    permitEffectiveDate:  string;
    paygovToken?:         string;
    paygovTrackingId?:    string;
    paygovError?:         string;
    purchaseDate?:        Date;
    created?:             Date;
    updated?:             Date;
    productUnitType:      string;   
    forestCode:           string;

    constructor(data: any) {
        this.permitId = data.permitId;
        this.permitNumber = data.permitNumber;
        this.processed = data.processed;
        this.product = data.product;
        this.productQuantity = data.productQuantity;
        this.forestId = data.forestId;
        this.orgStructureCode = data.orgStructureCode;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.emailAddress = data.emailAddress;
        this.woodCost = data.woodCost;
        this.quantity = data.quantity;
        this.totalCost = data.totalCost;
        this.status = data.status;
        this.permitteeInfo = data.permitteeInfo;
        this.permitExpireDate = data.permitExpireDate;
        this.permitEffectiveDate = data.permitEffectiveDate;
        this.paygovToken = data.paygovToken;
        this.paygovTrackingId = data.paygovTrackingId;
        this.paygovError = data.paygovError;
        this.purchaseDate = data.purchaseDate;
        this.created = data.created;
        this.updated = data.updated;
        this.productUnitType = data.productUnitType;
        this.forestCode = data.forestCode;
    }
}

export class HistoryDto {
    id:         number;
    permitId:   string;
    docType:    string;
    action:     string;
    newEmail?:  string;
    remarks:    string;
    userName:   string;
    createdBy:  number;
    createdAt:  Date;
    updatedBy:  number;
    updatedAt:  Date;

    constructor(data: any) {
        this.id = data.id;
        this.permitId = data.permitId;
        this.docType = data.docType;
        this.action = data.action;
        this.newEmail = data.newEmail;
        this.remarks = data.remarks;
        this.userName = data.userName;
        this.createdBy = data.createdBy;
        this.createdAt = data.createdAt;
        this.updatedBy = data.updatedBy;
        this.updatedAt = data.updatedAt;
    }
}

export class FeedbackDto {
    type:           string;
    firstName:      string;
    lastName:       string;
    emailAddress:   string;
    responseWanted: boolean;
    subject:        string;
    comments:       string;

    constructor(data) {
        this.type = data.type;
        this.firstName = data.first_name;
        this.lastName = data.last_name;
        this.emailAddress = data.email_address;
        this.subject = data.subject;
        this.responseWanted = data.responseWanted;
        this.comments = data.comments;
    }
}

export class SiteSettingsDto {
    name:           string;
    category:       string;
    enabled:        boolean;
    config:         JSON;
    description:    string;
    createdBy:      number;
    createdAt:      Date;
    updatedBy:      number;
    updatedAt:      Date;

    constructor(data: any) {
        this.name =  data.name;
        this.category =  data.category;
        this.enabled = data.enabled;
        this.config = data.config;
        this.description = data.description;
        this.createdBy = data.createdBy;
        this.createdAt = data.createdAt;
        this.updatedBy = data.updatedBy;
        this.updatedAt = data.updatedAt;
    }
}
